<template>
    <div class="py-4">
        <div class="flex flex-wrap gap-3 mb-4">
<div class="flex gap-3">
    <div>
          <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Başlangıç Tarihi</label>
          <input type="date"  v-model="filters.startDate" @change="handleDateChange('startDate', $event)"
            class="h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
        </div>
        <div>
          <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Bitiş Tarihi</label>
          <input type="date" v-model="filters.endDate" @change="handleDateChange('endDate', $event)"
            class="h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
        </div>
</div>
    
<div class="flex flex-wrap items-end gap-3">
    <!-- Category Selection -->
    <div class="w-full sm:w-52">
        <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Kategori</label>
        <button @click="openCategoryModal" 
                class="w-full h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50 text-left flex items-center justify-between">
            <span>{{ selectedCategoryName || 'Kategori Seçiniz' }}</span>
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
        </button>
    </div>

    <!-- Product Selection -->
    <div class="w-full sm:w-52">
        <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Ürün</label>
        <button @click="openProductModal" 
                :disabled="!filters.category"
                class="w-full h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50 text-left flex items-center justify-between disabled:opacity-50 disabled:cursor-not-allowed">
            <span>{{ selectedProductName || 'Ürün Seçiniz' }}</span>
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
        </button>
    </div>

    <!-- Dealer Selection -->
    <div class="w-full sm:w-52">
        <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Bayi</label>
        <button @click="openDealerModal" 
                class="w-full h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50 text-left flex items-center justify-between">
            <span>{{ selectedDealerName || 'Bayi Seçiniz' }}</span>
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
        </button>
    </div>

    <!-- Delivery Address Input -->
    <div class="w-full sm:w-52">
        <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Teslimat Adresi</label>
        <input type="text" 
               v-model="filters.deliveryAddress" 
               placeholder="Teslimat adresi giriniz"
               @input="filters.deliveryAddress = $event.target.value.toUpperCase()"
               class="h-10 px-3 w-full rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
    </div>
</div>

        
 
    <div class="flex gap-2 items-end justify-end">
        <button @click="onFilterClick"
          class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded text-sm">
          Filtrele
        </button>
        <button @click="resetFilters"
          class="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded text-sm dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100">
          Sıfırla
        </button>
</div>
    </div>

    <!-- Summary Cards -->
    <div v-if="summaryData" class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div class="bg-white dark:bg-gray-800 rounded-lg border border-light-border dark:border-gray-600 p-4 shadow-sm">
            <div class="flex items-center">
                <div class="flex-shrink-0">
                    <div class="w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center">
                        <svg class="w-4 h-4 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
                        </svg>
                    </div>
                </div>
                <div class="ml-3">
                    <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Toplam Teslimat</p>
                    <p class="text-lg font-semibold text-gray-900 dark:text-white">{{ summaryData.total_deliveries.toLocaleString('tr-TR') }}</p>
                </div>
            </div>
        </div>

        <div class="bg-white dark:bg-gray-800 rounded-lg border border-light-border dark:border-gray-600 p-4 shadow-sm">
            <div class="flex items-center">
                <div class="flex-shrink-0">
                    <div class="w-8 h-8 bg-green-100 dark:bg-green-900 rounded-lg flex items-center justify-center">
                        <svg class="w-4 h-4 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v3m0 3V9m3 3h3m-3 0h-3"></path>
                        </svg>
                    </div>
                </div>
                <div class="ml-3">
                    <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Toplam Tonaj</p>
                    <p class="text-lg font-semibold text-gray-900 dark:text-white">{{ formatWeight(summaryData.total_tonnage) }}</p>
                </div>
            </div>
        </div>

        <div class="bg-white dark:bg-gray-800 rounded-lg border border-light-border dark:border-gray-600 p-4 shadow-sm">
            <div class="flex items-center">
                <div class="flex-shrink-0">
                    <div class="w-8 h-8 bg-purple-100 dark:bg-purple-900 rounded-lg flex items-center justify-center">
                        <svg class="w-4 h-4 text-purple-600 dark:text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path>
                        </svg>
                    </div>
                </div>
                <div class="ml-3">
                    <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Toplam Komisyon</p>
                    <p class="text-lg font-semibold text-gray-900 dark:text-white">{{ formatPrice(summaryData.total_commission) }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Results Count -->
    <div v-if="totalOrdersCount > 0" class="mb-3">
        <p class="text-xs text-gray-500 dark:text-gray-400">
            {{ totalOrdersCount.toLocaleString('tr-TR') }} sonuç bulundu
        </p>
    </div>
      
        <div
            class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg dark:bg-primary-dark-bg pb-3 shadow-md">
            <div class="w-full overflow-x-auto">
                <table class="min-w-full text-left text-sm text-secondary-text dark:text-gray-300">
                    <thead class=" bg-gray-100 dark:bg-gray-800 font-medium">
                        <tr>
                            <th class="px-3 md:px-6 py-2 md:py-4">#</th>
                            <th class="px-3 md:px-6 py-2 md:py-4">Teslimat Zamanı</th>
                            <th class="px-3 md:px-6 py-2 md:py-4">Bayi Adı</th>
                            <th class="px-3 md:px-6 py-2 md:py-4">Kategori</th>
                            <th class="px-3 md:px-6 py-2 md:py-4">Ürün</th>
                            <th class="px-3 md:px-6 py-2 md:py-4">Tonaj</th>
                            <th class="px-3 md:px-6 py-2 md:py-4">Araç Plakası</th>
                            <th class="px-3 md:px-6 py-2 md:py-4">Dorse Plakası</th>
                            <th class="px-3 md:px-6 py-2 md:py-4">Teslimat Adresi</th>
                            <th class="px-3 md:px-6 py-2 md:py-4">Komisyon</th>
                            <th class="px-3 md:px-6 py-2 md:py-4">Yazdır</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="isLoading">
                            <td colspan="10" class="py-10 text-center text-gray-400">
                                <div class="flex justify-center items-center gap-2">
                                    <svg class="animate-spin h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg"
                                        fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                            stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                        </path>
                                    </svg>
                                    Yükleniyor...
                                </div>
                            </td>
                        </tr>

                        <tr v-if="orders.length === 0">
                            <td colspan="10" class="text-center py-6 text-gray-400">
                                Gösterilecek veri bulunamadı.
                            </td>
                        </tr>

                        <tr v-for="(order, index) in orders" :key="order.order_id"
                            class="border-b  text-primary-text dark:text-gray-100 hover:light-hover dark:hover:dark-hover transition">
    
                            <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-gray-600 dark:text-gray-400">
                                #{{ (currentPage - 1) * pageSize + index + 1 }}
                            </td>
                            <td class="px-3 md:px-6 py-2 md:py-4">{{ new Date(order.delivery_time).toLocaleDateString('tr-TR') || "---" }}</td>
                            <td class="px-3 md:px-6 py-2 md:py-4">{{ order.dealer_name }}</td>
                            <td class="px-3 md:px-6 py-2 md:py-4"> {{ order.categories.join(', ') }}</td>
                            <td class="px-3 md:px-6 py-2 md:py-4">{{order.products.map(p => p.name).join(', ')}}
                            </td>
                            <td class="px-3 md:px-6 py-2 md:py-4">
                                {{ formatWeight(order.delivery_tonnage || 0) }}
                            </td>
                            <td class="px-3 md:px-6 py-2 md:py-4">
                                {{ order.delivery_plate || "---" }}
                            </td>
                            <td class="px-3 md:px-6 py-2 md:py-4">
                                {{ order.delivery_trailer || "---" }}
                            </td>
                            <td class="px-3 md:px-6 py-2 md:py-4">
                                {{ order.delivery_shipment_address || "---" }}
                            </td>
                          
                            <td class="px-3 md:px-6 py-2 md:py-4">{{ formatPrice(order.commission) }}</td>
                            <td class="px-3 md:px-6 py-2 md:py-4">
                                <button @click="openReprintChoice(order)" class="bg-primary-button hover:bg-primary-button-hover text-white px-3 py-1 rounded text-xs"
                                    :disabled="!order.delivery_id">
                                    Yazdır
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

                <AppPagination
                    :currentPage="currentPage"
                    :totalPages="totalPages"
                    :pageSize="pageSize"
                    :totalItems="totalOrdersCount"
                    @prev-page="currentPage--"
                    @next-page="currentPage++"
                    @go-to-page="page => currentPage = page"
                    @update:pageSize="onPageSizeChange"
                />
     
        </div>
    </div>

    <!-- Reprint Choice Modal -->
    <div v-if="showReprintModal" @click.self="closeReprintChoice" class="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div class="bg-primary-bg dark:bg-primary-dark-bg p-6 rounded-lg border border-light-border dark:border-dark-border w-full max-w-md relative">
        <button @click="closeReprintChoice" class="absolute top-2 right-2 text-gray-500 hover:text-black text-lg font-bold">
          ✕
        </button>
        <h3 class="text-lg font-semibold mb-4 text-primary-text dark:text-gray-100">Belge Türü Seçin</h3>
        <div class="space-y-3">
          <button @click="handleReprint('invoice')" class="w-full px-4 py-2 rounded bg-primary-button text-white hover:bg-primary-button-hover">Yükleme Talimatı</button>
          <button @click="handleReprint('waybill')" class="w-full px-4 py-2 rounded bg-indigo-600 text-white hover:bg-indigo-700">Taşıma İrsaliyesi</button>
        </div>
      </div>
    </div>

    <!-- Print Preview Modal (reprint) -->
    <PrintPreviewModal
      v-if="showPrintPreview"
      :selectedOrders="printSelectedOrders"
      :driver="printDriver"
      :vehicle="printVehicle"
      :waybill="printWaybill"
      :mode="printMode"
      @close="closePrintPreview"
      @cancel="closePrintPreview"
      @confirm-preview="closePrintPreview"
    />

    <!-- Select Modals -->
    <SelectModal
        :isOpen="categoryModalOpen"
        title="Kategori Seçiniz"
        :options="categoryOptions"
        :selectedValue="selectedCategory"
        labelKey="category_name"
        valueKey="category_id"
        searchPlaceholder="Kategori ara..."
        @select="onCategorySelect"
        @confirm="onCategoryConfirm"
        @clear="onCategoryClear"
        @close="categoryModalOpen = false"
        @search="onCategorySearch"
    />

    <SelectModal
        :isOpen="productModalOpen"
        title="Ürün Seçiniz"
        :options="productOptions"
        :selectedValue="selectedProduct"
        labelKey="name"
        valueKey="id"
        searchPlaceholder="Ürün ara..."
        @select="onProductSelect"
        @confirm="onProductConfirm"
        @clear="onProductClear"
        @close="productModalOpen = false"
        @search="onProductSearch"
    />

    <SelectModal
        :isOpen="dealerModalOpen"
        title="Bayi Seçiniz"
        :options="dealerOptions"
        :selectedValue="selectedDealer"
        labelKey="dealer_name"
        valueKey="dealer_id"
        searchPlaceholder="Bayi ara..."
        @select="onDealerSelect"
        @confirm="onDealerConfirm"
        @clear="onDealerClear"
        @close="dealerModalOpen = false"
        @search="onDealerSearch"
    />
</template>

<script>
import { getApi, postApi } from "@/services/api";
// import { EyeIcon } from "@heroicons/vue/24/outline";
import AppPagination from "@/components/AppPagination.vue";
import SelectModal from "@/components/Modals/SelectModal.vue";
import { DateTime } from "luxon"
import PrintPreviewModal from "@/components/Modals/PrintPreviewModal.vue";

export default {
    name: "OrderAnalysis",
    components: {
        // EyeIcon,
        AppPagination,
        SelectModal,
        PrintPreviewModal,
    },
    data() {
        return {
            currentPage: 1,
            pageSize: 50,
            orders: [],
            categories: [],
            filters: {
                startDate: DateTime.now().toFormat("yyyy-MM-dd"),
                endDate: DateTime.now().toFormat("yyyy-MM-dd"),
                category: null,
                productId: null,
                dealerId: null,
                deliveryAddress: null,
            },
            products: [],
            dealerOptions: [],
            dealerQuery: "",
            isLoading: false,
            totalOrdersCount: 0,
            productSearchQuery: "",
            
            // Modal states
            categoryModalOpen: false,
            productModalOpen: false,
            dealerModalOpen: false,
            
            // Selected values for display
            selectedCategory: null,
            selectedProduct: null,
            selectedDealer: null,
            
            // Options for modals
            categoryOptions: [],
            productOptions: [],

            // Reprint state
            showReprintModal: false,
            reprintTargetOrder: null,
            showPrintPreview: false,
            printMode: 'invoice',
            printSelectedOrders: [],
            printDriver: {},
            printVehicle: {},
            printWaybill: {},
            
            // Summary data
            summaryData: null,
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalOrdersCount / this.pageSize);
        },
        selectedCategoryName() {
            return this.selectedCategory ? this.selectedCategory.category_name : null;
        },
        selectedProductName() {
            return this.selectedProduct ? this.selectedProduct.name : null;
        },
        selectedDealerName() {
            return this.selectedDealer ? this.selectedDealer.dealer_name : null;
        },
    },

    methods: {
        formatPrice(value) {
            if (value === null || value === undefined) return '0,00';
            const parts = parseFloat(value).toFixed(2).split('.');
            const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            const decimalPart = parts[1];
            return `${integerPart},${decimalPart}`;
        },
        formatNumber(value) {
            if (value === null || value === undefined) return '0';
            return parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        formatWeight(value) {
            if (value === null || value === undefined || value === '') return '';
            const num = Number(value);
            if (num >= 1000) {
                return num.toLocaleString('tr-TR');
            } else {
                return num.toString();
            }
        },

        handleDateChange(field, event) {
            this.filters[field] = event.target.value;

            event.target.blur();
        },
        onFilterClick() {
            this.currentPage = 1;
            this.fetchOrders();
            this.fetchSummaryData();
        },
        onPageSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1;
            this.fetchOrders();
        },

        async fetchCategories() {
            try {
                const response = await getApi("/categories/");
                this.categories = response || [];
                this.categoryOptions = this.categories;
            } catch (e) {
                console.error("Kategori yüklenemedi:", e);
            }
        },
        resetFilters() {
            this.filters = {
                startDate: DateTime.now().toFormat("yyyy-MM-dd"),
                endDate: DateTime.now().toFormat("yyyy-MM-dd"),
                category: null,
                productId: null,
                dealerId: null,
                deliveryAddress: null,
            };
            this.products = [];
            this.productOptions = [];
            this.selectedCategory = null;
            this.selectedProduct = null;
            this.selectedDealer = null;
            this.currentPage = 1;
            this.summaryData = null;
            this.fetchInitialDealers();
            this.fetchOrders();
            this.fetchSummaryData();
        },
        async fetchInitialDealers() {
            try {
                const res = await getApi(`/dealers/50/0`);
                this.dealerOptions = Array.isArray(res?.dealers) ? res.dealers : [];
            } catch (e) {
                this.dealerOptions = [];
            }
        },


        async fetchProductsByCategory() {
            if (!this.filters.category) { 
                this.products = []; 
                this.productOptions = [];
                this.filters.productId = null; 
                return; 
            }
            
            try {
                if (this.productSearchQuery && this.productSearchQuery.length >= 2) {
                    const response = await getApi(`/products/search?category_id=${this.filters.category}&q=${this.productSearchQuery}`);
                    this.products = response || [];
                    this.productOptions = this.products;
                } else {
                    const response = await getApi(`/products/category/${this.filters.category}`);
                    this.products = response || [];
                    this.productOptions = this.products;
                }
            } catch (e) {
                this.products = [];
                this.productOptions = [];
            }
        },

        showReceipt(order) {
            if (!order.hasReceipt) {
                this.$toast?.error("Bu sipariş için teslimat bilgisi bulunmamaktadır.");
                return;
            }
            alert(`Fiş gösterilecek: ${order.dealer_name} - ${order.delivery_plate}`);
        },

        // Reprint flow
        openReprintChoice(order) {
            this.reprintTargetOrder = order;
            this.showReprintModal = true;
        },
        closeReprintChoice() {
            this.showReprintModal = false;
            this.reprintTargetOrder = null;
        },
        async fetchDriverById(driverId) {
            const normalizedId = Number(driverId);
            if (!Number.isInteger(normalizedId) || normalizedId <= 0) return {};
            try {
                return await getApi(`/drivers/${normalizedId}`);
            } catch (e) {
                return {};
            }
        },
        async handleReprint(mode) {
            try {
                if (!this.reprintTargetOrder) return;
                this.printMode = mode; // 'invoice' or 'waybill'

                // Fetch canonical delivery by id to ensure original data
                const deliveryId = this.reprintTargetOrder.delivery_id || this.reprintTargetOrder.id;
                if (!deliveryId) {
                    this.$toast?.error('Teslimat bilgisi bulunamadı.');
                    return;
                }

                const delivery = await getApi(`/deliveries/${deliveryId}`);
                // delivery contains: dealer, product, commission, driver?, etc.

                const dealer = delivery?.dealer || {};
                const product = delivery?.product || {};
                let driver = delivery?.commission?.driver || delivery?.driver || {};
                if (!driver?.driver_id) {
                    driver = await this.fetchDriverById(delivery?.drivers_id);
                }

                const vehiclePlate = delivery?.delivery_plate || '';
                const trailerPlate = delivery?.delivery_trailer || '';
                const billId = delivery?.bill_id || '';
                const deliveryMethod = (delivery?.delivery_method || 'fot').toLowerCase();
                const deliveryAddress = delivery?.delivery_shipment_address || '';
                const quantity = Number(delivery?.delivery_tonnage || 0);

                // Build common structures for the preview modal
                const selectedOrder = {
                    id: delivery?.order_id || 0,
                    orderNumber: delivery?.order?.order_number || this.reprintTargetOrder.order_number || this.reprintTargetOrder.order_id || '#',
                    companyName: dealer?.dealer_name || 'Bayi Bilgisi Yok',
                    deliveryLocation: deliveryAddress,
                    loadProducts: [{ urun_name: product?.name || '-' }],
                    loadingTonnage: quantity,
                    deliveryMethod,
                    bill_id: billId,
                };

                this.printSelectedOrders = [selectedOrder];
                this.printDriver = {
                    driver_name: driver?.driver_name || '',
                    driver_telno: driver?.driver_telno || '',
                    driver_tcno: driver?.driver_tcno || '',
                    driver_licenceno: driver?.driver_licenceno || '',
                    address: driver?.driver_address || '',
                };
                this.printVehicle = {
                    plate: vehiclePlate || '-',
                    trailer: trailerPlate || '-',
                };

                // For waybill mode, we must supply waybill object exactly like PendingDeliveries does
                if (mode === 'waybill') {
                    this.printWaybill = {
                        no: billId || (deliveryMethod === 'fot' ? 'FOT' : 'CIF'),
                        bill_id: billId,
                        date: new Date(delivery?.delivery_time || Date.now()).toLocaleDateString('tr-TR'),
                        sender: '',
                        loadingLocation: '',
                        deliveryMethod,
                        unit_price: delivery?.unit_price || 0,
                        items: [
                            {
                                id: 1,
                                customer: dealer?.dealer_name || 'Bayi',
                                destination: deliveryAddress || 'Adres Yok',
                                type: product?.name || 'Ürün Yok',
                                quantity,
                                price: delivery?.unit_price || 0,
                            },
                        ],
                    };
                } else {
                    // Invoice (Yükleme Talimatı) doesn't require waybill-specific totals, but component expects prop
                    this.printWaybill = { items: [] };
                }

                this.showReprintModal = false;
                this.showPrintPreview = true;
            } catch (e) {
                this.$toast?.error('Belge hazırlanırken hata oluştu.');
            }
        },
        closePrintPreview() {
            this.showPrintPreview = false;
            this.printSelectedOrders = [];
            this.printDriver = {};
            this.printVehicle = {};
            this.printWaybill = {};
        },

        async fetchSummaryData() {
            try {
                const { startDate, endDate, category, productId, dealerId, deliveryAddress } = this.filters;

                const start = DateTime.fromISO(startDate);
                const end = DateTime.fromISO(endDate);

                const filterPayload = {
                    start: start.isValid ? start.toFormat("yyyy-MM-dd'T'HH:mm:ss") : null,
                    end: end.isValid ? end.toFormat("yyyy-MM-dd'T'HH:mm:ss") : null,
                    is_approved: 1,
                };

                if (category !== null && category !== undefined) {
                    filterPayload.category = category;
                }
                if (productId !== null && productId !== undefined) {
                    filterPayload.product_id = productId;
                }
                if (dealerId !== null && dealerId !== undefined) {
                    filterPayload.dealer_id = dealerId.dealer_id || dealerId;
                }

                if (deliveryAddress !== null && deliveryAddress !== undefined && deliveryAddress.trim() !== '') {
                    filterPayload.deliveryAddress = deliveryAddress.trim();
                }

                const summaryResp = await postApi('/deliveries/analytics-summary', filterPayload);
                this.summaryData = summaryResp;
            } catch (error) {
                console.error("fetchSummaryData error:", error);
                this.summaryData = null;
            }
        },

        async fetchOrders() {
            this.isLoading = true;
            this.orders = [];

            try {
                const { startDate, endDate, category, productId, dealerId, deliveryAddress } = this.filters;

                const take = this.pageSize;
                const skip = (this.currentPage - 1) * this.pageSize;

                const start = DateTime.fromISO(startDate);
                const end = DateTime.fromISO(endDate);

                const filterPayload = {
                    start: start.isValid ? start.toFormat("yyyy-MM-dd'T'HH:mm:ss") : null,
                    end: end.isValid ? end.toFormat("yyyy-MM-dd'T'HH:mm:ss") : null,
                    is_approved: 1,
                };

                if (category !== null && category !== undefined) {
                    filterPayload.category = category;
                }
                if (productId !== null && productId !== undefined) {
                    filterPayload.product_id = productId;
                }
                if (dealerId !== null && dealerId !== undefined) {
                    filterPayload.dealer_id = dealerId.dealer_id || dealerId;
                }

                if (deliveryAddress !== null && deliveryAddress !== undefined && deliveryAddress.trim() !== '') {
                    filterPayload.deliveryAddress = deliveryAddress.trim();
                }

                const deliveryResp = await postApi(`/deliveries/filter/${take}/${skip}`, filterPayload);
                const deliveries = deliveryResp?.deliveries || [];

                this.orders = deliveries.map(d => {
                    const order = d.order || {};
                    const dealer = d.dealer || {};
                    const product = d.product || {};

                    return {
                        ...d,
                        order_time: order.order_time || "",
                        delivery_time: d.delivery_time || "", 
                        dealer_name: dealer.dealer_name || "Bilinmeyen Bayi",
                        products: [{ name: product.name || "-" }],
                        categories: [product.category?.category_name || "-"],
                        categoryIds: [product.category?.category_id],
                        commission: d.commission?.commission_amount || null,
                        hasReceipt: true,
                    };
                });

                this.totalOrdersCount = deliveryResp?.total_result || this.orders.length;
                console.log('Total results from backend:', deliveryResp?.total_result);
                console.log('Orders length:', this.orders.length);
            } catch (error) {
                console.error("fetchOrders error:", error);
                this.orders = [];
            } finally {
                this.isLoading = false;
            }
        },

        // Modal methods
        openCategoryModal() {
            this.categoryModalOpen = true;
        },
        openProductModal() {
            if (!this.filters.category) return;
            this.productModalOpen = true;
        },
        openDealerModal() {
            this.dealerModalOpen = true;
        },

        // Category modal methods
        onCategorySelect(category) {
            this.selectedCategory = category;
        },
        onCategoryConfirm() {
            this.filters.category = this.selectedCategory ? this.selectedCategory.category_id : null;
            this.filters.productId = null;
            this.selectedProduct = null;
            this.productOptions = [];
            this.categoryModalOpen = false;
        },
        onCategoryClear() {
            this.selectedCategory = null;
            this.filters.category = null;
            this.filters.productId = null;
            this.selectedProduct = null;
            this.productOptions = [];
        },
        onCategorySearch(query) {
            // Filter categories based on search query
            if (!query || query.length < 2) {
                this.categoryOptions = this.categories;
                return;
            }
            this.categoryOptions = this.categories.filter(cat => 
                cat.category_name.toLowerCase().includes(query.toLowerCase())
            );
        },

        // Product modal methods
        onProductSelect(product) {
            this.selectedProduct = product;
        },
        onProductConfirm() {
            this.filters.productId = this.selectedProduct ? this.selectedProduct.id : null;
            this.productModalOpen = false;
        },
        onProductClear() {
            this.selectedProduct = null;
            this.filters.productId = null;
        },
        async onProductSearch(query) {
            if (!this.filters.category) return;
            
            if (!query || query.length < 2) {
                await this.fetchProductsByCategory();
                return;
            }
            
            try {
                const response = await getApi(`/products/search?category_id=${this.filters.category}&q=${encodeURIComponent(query)}`);
                this.productOptions = response || [];
            } catch (e) {
                this.productOptions = [];
            }
        },

        // Dealer modal methods
        onDealerSelect(dealer) {
            this.selectedDealer = dealer;
        },
        onDealerConfirm() {
            this.filters.dealerId = this.selectedDealer ? this.selectedDealer.dealer_id : null;
            this.dealerModalOpen = false;
        },
        onDealerClear() {
            this.selectedDealer = null;
            this.filters.dealerId = null;
        },
        async onDealerSearch(query) {
            if (!query || query.length < 2) {
                await this.fetchInitialDealers();
                return;
            }
            
            try {
                const res = await getApi(`/dealers/search?q=${encodeURIComponent(query)}`);
                this.dealerOptions = Array.isArray(res) ? res.map(dealer => ({
                    dealer_id: dealer.dealer_id || dealer.id,
                    dealer_name: dealer.dealer_name || dealer.name
                })) : [];
            } catch (e) {
                this.dealerOptions = [];
            }
        },
    },
    mounted() {
        this.fetchCategories();
        this.fetchInitialDealers();
        this.fetchOrders();
        this.fetchSummaryData();
    },

    watch: {
        'filters.category'() {
            this.fetchProductsByCategory();
            // Reset product selection when category changes
            this.selectedProduct = null;
            this.filters.productId = null;
        },
        currentPage() {
            this.fetchOrders();
        }
    }


};
</script>
